import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentindaundpune() {



const cardData =
  {
    keyword: 'Bus On Rent in Daund Pune',
    heading: 'Sanavi Travels: Bus On Rent in Daund Pune',
    headingDescription: 'Sanavi Travels offers Bus On Rent in Daund Pune, delivering safe, spacious, and highly reliable transportation solutions for families, large groups, corporate travel, school excursions, weddings, picnics, and outstation journeys. Daund is a major railway junction and commercial hub in Pune district, generating constant movement of people for business, education, social events, and tourism. To support this demand, we provide a wide fleet of well-maintained AC buses, Non-AC buses, mini buses, luxury coaches, and high-capacity buses designed for both short and long-distance travel. Every bus is equipped with comfortable seating, sufficient legroom, proper ventilation, and ample luggage space to ensure a relaxed and fatigue-free journey. With experienced and route-familiar drivers, flexible rental options such as one-way, round-trip, and multi-day packages, transparent pricing with no hidden costs, and 24/7 customer support, bus rental in Daund Pune becomes a smooth and stress-free experience. Choose Sanavi Travels for trusted bus rental services in Daund Pune, ensuring punctuality, comfort, safety, and seamless group travel for every occasion.',

    top: 'Top Places to Visit in Daund Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Daund City",
    "description": "Daund is a prominent town in Pune district known for its railway junction, markets, and residential areas. It serves as a central travel point for nearby towns and villages, making bus rentals ideal for organized group movement."
  },
  {
    "title": "Daund Railway Junction",
    "description": "One of the busiest railway junctions in Maharashtra, Daund Railway Junction attracts daily travelers. Bus services are frequently hired for group transfers, pilgrimages, and coordinated travel."
  },
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Bhigwan, located close to Daund, is famous for migratory birds and scenic backwaters. Buses are commonly hired for picnics, educational trips, photography tours, and family outings."
  },
  {
    "title": "Jejuri Khandoba Temple",
    "description": "Jejuri is a well-known pilgrimage destination near Daund. Bus rentals provide convenient and safe transport for large religious groups and festival travelers."
  },
  {
    "title": "Industrial and MIDC Areas",
    "description": "Daund has access to several industrial zones where buses are regularly used for employee transport, factory visits, and corporate travel."
  },
  {
    "title": "Agricultural Villages",
    "description": "Surrounding villages around Daund are agriculturally rich and often visited during rural tours, school excursions, and social events requiring group transportation."
  },
  {
    "title": "Local Markets and Mandis",
    "description": "Daund’s markets and trading centers attract traders and visitors from nearby regions, making bus travel a practical option for group visits."
  },
  {
    "title": "Wedding Venues in Daund",
    "description": "Several marriage halls and wedding lawns in Daund depend on bus rentals for guest transportation and smooth event logistics."
  },
  {
    "title": "Picnic and Leisure Spots",
    "description": "Open spaces, riversides, and leisure areas around Daund are popular for school picnics and family outings where buses offer safe group travel."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Daund is well connected to Shirdi, Solapur, Pune, Nashik, Kolhapur, and Mumbai, making it ideal for long-distance bus travel."
  }
]
,



"services": [
{
"name": "Bus On Rent in Daund Pune",
"description": "Bus On Rent in Daund Pune provides spacious, clean, and comfortable buses for families, social groups, tourists, schools, and corporate clients. This service is ideal for weddings, religious tours, picnics, sightseeing trips, school excursions, and long-distance outstation travel. Our buses are designed to handle heavy passenger movement while ensuring comfort through cushioned seating, proper ventilation, smooth suspension, and sufficient luggage space. Professional drivers manage routes, traffic, and schedules efficiently, ensuring passengers experience safe, punctual, and stress-free journeys from start to finish."
},
{
"name": "Bus Hire in Daund Pune",
"description": "Bus Hire in Daund Pune offers flexible and dependable transportation solutions for short-distance and long-distance group travel. Whether it is a family function, corporate outing, school trip, or social event, our bus hire service ensures organized travel with disciplined operations, timely pickups, and reliable service. Multiple seating options allow customers to choose buses according to group size, travel duration, and budget requirements."
},
{
"name": "AC Bus Rental Daund",
"description": "AC Bus Rental Daund is ideal for travelers seeking maximum comfort during travel, especially in hot weather and on long routes. Fully air-conditioned interiors, comfortable seating, proper airflow, and smooth driving experience make AC buses suitable for corporate travel, weddings, tourist groups, and outstation journeys. This service ensures passengers remain relaxed and refreshed throughout the journey."
},
{
"name": "Non AC Bus on Rent Daund",
"description": "Non AC Bus on Rent Daund provides a budget-friendly transportation option for local travel, rural routes, school trips, and short-distance group journeys. These buses are well-maintained, spacious, and reliable, making them a practical choice for cost-conscious customers without compromising safety or basic comfort."
},
{
"name": "Luxury Bus on Rent Daund Pune",
"description": "Luxury Bus on Rent Daund Pune delivers a premium travel experience with modern interiors, elegant seating layouts, and enhanced comfort features. These buses are ideal for weddings, VIP travel, corporate events, and special occasions where style and comfort are equally important. Luxury buses ensure a smooth, quiet, and memorable journey for all passengers."
},
{
"name": "Mini Bus Hire Daund",
"description": "Mini Bus Hire Daund is suitable for small to medium-sized groups such as family outings, local events, office teams, and short tours. Mini buses offer easy maneuverability, comfortable seating, and economical pricing while still maintaining safety and reliability."
},
{
"name": "32 Seater Bus on Rent Daund",
"description": "32 Seater Bus on Rent Daund is perfect for medium-sized groups including school excursions, office trips, social gatherings, and tourist travel. These buses offer balanced seating capacity, adequate luggage space, and smooth travel experience for both local and outstation routes."
},
{
"name": "35 Seater Bus Hire Daund Pune",
"description": "35 Seater Bus Hire Daund Pune supports larger group travel needs such as weddings, corporate travel, school tours, and religious trips. With spacious seating arrangements, experienced drivers, and dependable service, this option ensures comfortable and organized group transportation."
},
{
"name": "Bus on Rent Daund for Wedding",
"description": "Bus on Rent Daund for Wedding ensures timely and coordinated transportation for wedding guests, family members, and relatives. These buses help manage large crowds efficiently, reduce travel stress, and ensure guests reach venues comfortably and on time."
},
{
"name": "Bus Rental Daund for Corporate",
"description": "Bus Rental Daund for Corporate travel supports employee transportation, meetings, conferences, factory visits, and corporate events. The service focuses on punctuality, professionalism, and comfort, helping organizations manage group movement efficiently."
},
{
"name": "Bus on Rent Daund for Picnic",
"description": "Bus on Rent Daund for Picnic offers safe, reliable, and comfortable transportation for school picnics, family outings, and leisure trips. These buses ensure group members travel together, making the trip enjoyable and well-coordinated."
},
{
"name": "Bus on Rent Daund for Outstation",
"description": "Bus on Rent Daund for Outstation provides dependable long-distance travel solutions to popular destinations such as Shirdi, Nashik, Solapur, Kolhapur, Pune, and Mumbai. Designed for extended journeys, these buses ensure passenger comfort and safety throughout the trip."
},
{
"name": "Bus Hire Daund with Driver",
"description": "Bus Hire Daund with Driver offers chauffeur-driven buses where experienced drivers handle navigation, traffic conditions, and route planning. This allows passengers to relax and enjoy the journey without worrying about logistics."
},
{
"name": "Affordable Bus Rental Daund Pune",
"description": "Affordable Bus Rental Daund Pune provides cost-effective transportation options for groups seeking economical travel without compromising on safety, cleanliness, or reliability. Ideal for schools, families, and budget-conscious travelers."
},
{
"name": "Best Bus Service in Daund",
"description": "Best Bus Service in Daund is trusted for clean buses, disciplined drivers, transparent pricing, and customer-focused service. Sanavi Travels ensures every journey is smooth, punctual, and comfortable, making it a preferred choice for group travel in Daund."
}
],
"tableData": [
["Bus On Rent in Daund Pune", "Bus Hire in Daund Pune"],
["AC Bus Rental Daund", "Non AC Bus on Rent Daund"],
["Luxury Bus on Rent Daund Pune", "Mini Bus Hire Daund"],
["32 Seater Bus on Rent Daund", "35 Seater Bus Hire Daund Pune"],
["Wedding Bus Daund", "Corporate Bus Daund"],
["Picnic Bus Daund", "Outstation Bus Daund"],
["Bus Hire Daund with Driver", "Affordable Bus Rental Daund Pune"],
["Best Bus Service in Daund", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Daund Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels is a trusted provider of bus rental services in Daund Pune, offering dependable transportation for families, corporate groups, schools, and social events."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are regularly serviced, clean, and designed to provide a smooth and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are licensed, disciplined, and familiar with Daund routes, highways, and outstation destinations."
  },
  {
    "WhyChooseheading": "Transparent Pricing Policy",
    "WhyChoosedescription": "We follow honest pricing with no hidden charges, ensuring clarity and trust for every booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team remains available round the clock to assist with bookings and journey coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "We provide hourly, full-day, multi-day, and customized bus rental plans to match different travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every bus is thoroughly cleaned and sanitized before each journey to ensure passenger safety."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "We ensure on-time pickups and disciplined operations, making Sanavi Travels a reliable choice in Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Daund Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Daund Pune for all types of group travel.'
  },
  {
    question: 'How can I book a bus in Daund Pune?',
    answer: 'You can book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available in Daund Pune?',
    answer: 'We offer AC buses, Non-AC buses, mini buses, luxury buses, 32-seater and 35-seater buses.'
  },
  {
    question: 'Is bus rental available for weddings and corporate events?',
    answer: 'Yes, we provide dedicated bus services for weddings, corporate travel, and social events.'
  },
  {
    question: 'Are buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before each journey.'
  },
  {
    question: 'Is bus service available for outstation travel?',
    answer: 'Yes, we offer bus rentals from Daund to various outstation destinations.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, debit cards, credit cards, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our customer support team is available throughout the journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Kulkarni',
    feedback: 'We hired a bus from Daund for a wedding. The service was punctual and the bus was very comfortable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Sanavi Travels arranged a bus for our picnic from Daund. Excellent service and smooth journey.',
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent in Daund Pune - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Daund Pune for weddings, corporate travel, picnics, and outstation trips. Choose from AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable prices.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "190"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus on Rent in Daund Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Daund Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation journeys with driver at best rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/214.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentindaundpune;